<template lang="">
    <section
        class="bg-white sm:px-2 rounded-2xl flex flex-col items-center justify-center gap-y-2 p-4"
    >
        <div class="grid grid-icon-template gap-x-2">
            <Icon class="text-primary mt-1" name="House" />
            <h2 v-if="!currentActivity" class="pb-2 pt-0 text-xl text-[#808080]">
                Informe sua localização para enviar fotos da sua execução
            </h2>
            <div class="pb-2 pt-0 text-xl text-[#808080]" v-else>
                <h2>Loja {{ currentActivity?.pdv?.name }}</h2>
                <h2>Sub-regional {{ currentActivity?.subregion?.name }}</h2>
            </div>
        </div>

        <div class="w-[min-content] whitespace-nowrap sm:block mt-4">
            <Button @click="toggleIsChangeModalOpen" class="py-1">{{
                currentActivity ? "Mudar localização" : "Enviar localização"
            }}</Button>
        </div>

        <section v-if="currentActivity">
            <div class="flex flex-col gap-y-2">
                <h3 class="py-2 text-lg">Selecione uma campanha abaixo para enviar as fotos de sua execução</h3>
                <div class="max-h-[200px]" :class="{'overflow-auto': contestList.length}">
                    <div v-if="isLoading" class="flex justify-center">
                        <Loading
                            :size="10"
                        />
                    </div>
                    <div v-if="contestList.length" v-for="contest in contestList" class="grid grid-campaign-card-template gap-x-2 p-4 border-[1px] rounded-[4px] hover:bg-[#05539033] cursor-pointer" @click="updateContest(contest?.id)">
                        <img :src="contest.imgUrl || '/images/campaign-not-found.png'" class="mt-1 w-[50px] max-w-[50px] h-[50px] rounded-[4px] bg-black" onerror="this.src = '/images/campaign-not-found.png'">
                        <div>
                            <h4 class="text-md">{{ handleContestName(contest) }}</h4>
                            <h4 class="text-sm" v-if="!!getContestRegionalGoal(contest)?.region?.regionId"><strong>Meta sub-regional</strong>: {{ getContestRegionalGoal(contest)?.target || 0}}</h4>
                            <h4 class="text-sm" v-else ><strong>Meta regional</strong>: {{ getContestRegionalGoal(contest)?.target || 0}}</h4>
                            <h4 class="text-sm"><strong>Fotos enviadas por você</strong>: {{ contest?.galleriesCount || 0 }}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <ChangeSoldCheckinModal :currentRegion="currentRegion" :showModal="isChangeModalOpen" @closeModal="toggleIsChangeModalOpen"/>
    </section>
</template>
<script>

import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from '@/Components/Button.vue'
import ChangeSoldCheckinModal from "@/Components/UI/Modals/ChangeSoldCheckinModal.vue";
import SearchableExpandableRadio from "@/Components/SearchableExpandableRadio.vue";
import moment from 'moment';
import Loading from '@/Components/Loading.vue'


export default {
    components: {
        Button,
        Icon,
        ChangeSoldCheckinModal,
        SearchableExpandableRadio,
        Loading,
    },

    props: {
        currentRegion: Object,
    },

    emits: ['updateContest'],
    data() {
        return {
            isChangeModalOpen: false,
            contests: [],
            isLoadingContest: false,
        }
    },
    watch: {
        currentActivity: {
            handler(newValue, oldValue) {
                if(oldValue?.subregion?.id != newValue?.subregion?.id) {
                    this.fetchContests(newValue?.subregion?.id);
                }
            },
            immediate: true
        }
    },

    methods: {
        getContestRegionalGoal(contest) {
            return contest?.regionalGoal?.length > 0 ? contest?.regionalGoal[0]: undefined;
        },
        updateContest(contestId) {
            this.$emit('updateContest', contestId);
        },
        handleContestName(contest) {
            return `${contest.name} (${moment(contest.startDate)
                .locale("pt-br")
                .format("MMMM")
                .toUpperCase()} à ${moment(contest.endDate)
                    .locale("pt-br")
                    .format("MMMM")
                    .toUpperCase()})`;
        },
        toggleIsChangeModalOpen() {
            this.isChangeModalOpen = !this.isChangeModalOpen;
        },
        fetchContests(subregionId) {
            if(!subregionId) return;

            this.isLoadingContest = true;
            axios
                .get(this.route('contest.options', { subregionId, loadPhotosCount: true }), {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(({ data }) => {
                    const { contests } = data;

                    this.contests = contests || [];
                    this.isLoadingContest = false;
                }).catch(err => {
                    this.isLoadingContest = false;
                    console.log(err);
                });
        },
    },

    computed: {
        contestList() {
            return this.contests.sort((a, b) => {
                if (a.name === b.name)
                    return moment(a.startDate).isBefore(moment(b.startDate))? -1: 1;
                else
                    return b.name?.localeCompare(a.name)? -1: 1;
            })
        },
        currentActivity() {
            return this.$page.props.auth.user.participant.currentActivity;
        },
        isLoading() {
            return this.isLoadingContest;
        }
    }
}
</script>

<style>
.grid-campaign-card-template {
    grid-template-columns: min-content auto;
}
</style>
